import { render, staticRenderFns } from "./login-dialog.vue?vue&type=template&id=139bc253&"
import script from "./login-dialog.vue?vue&type=script&lang=js&"
export * from "./login-dialog.vue?vue&type=script&lang=js&"
import style0 from "./login-dialog.vue?vue&type=style&index=0&id=139bc253&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports